import { Input } from '@chakra-ui/react';
import styled, { css } from 'styled-components';
import arrowDown from '@/assets/arrow-down.svg';

type TopBarLinkType = {
  isActived?: boolean;
};

const activedDot = css<TopBarLinkType>`
  &:after {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    background: ${(props) => props.theme.colors['primary-60']};
    border-radius: 50%;
    bottom: -10px;
    left: 0;
    right: 0;
    margin: auto;
    display: ${(props) => (props.isActived ? 'initial' : 'none')};
  }
`;

export const TopBarLink = styled.button<TopBarLinkType>`
  cursor: pointer;
  background-color: transparent;
  border: 0;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${(props) =>
    props.isActived ? props.theme.colors['primary-60'] : props.theme.colors['neutral-80']};
  position: relative;
  &:not(&:last-of-type) {
    margin-right: 24px;
  }
  ${activedDot};
  &:hover {
    color: ${(props) =>
      props.isActived ? props.theme.colors['primary-60'] : props.theme.colors['primary-40']};
  }
  &:active {
    color: ${(props) => props.theme.colors['primary-30']};
  }
`;

export const Title = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const TitleArea = styled.div`
  display: flex;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const InputDate = styled(Input)`
  ::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 7px;
    right: 8px;
    background: url(${arrowDown}) center/70% no-repeat;
  }
`;
